import React from "react";

export function PortalLoader({ leaving = false }) {
  return (
    <div className={`portal-loader ${leaving ? "is-leaving" : ""}`} aria-hidden="true">
      <div className="portal-loader__logo-wrap">
        <svg className="portal-loader__ring portal-loader__ring--one" viewBox="0 0 1128.5 531.93" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M564.25 531.93L0 265.96 564.25 0l564.25 265.96-564.25 265.97ZM126.17 265.96l438.08 206.49 438.08-206.49L564.25 59.47 126.17 265.96Z" fill="currentColor" />
        </svg>
        <svg className="portal-loader__ring portal-loader__ring--two" viewBox="0 0 988.98 477.4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M494.49 477.4 0 238.7 494.49 0l494.49 238.7L494.49 477.4ZM110.57 238.7l383.92 185.32L878.41 238.7 494.49 53.38 110.57 238.7Z" fill="currentColor" />
        </svg>
        <svg className="portal-loader__ring portal-loader__ring--three" viewBox="0 0 883.58 416.49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M441.79 416.49 0 208.24 441.79 0l441.79 208.24-441.79 208.25ZM98.99 208.24l342.8 161.68 342.8-161.68L441.79 46.56 98.99 208.24Z" fill="currentColor" />
        </svg>
      </div>
    </div>
  );
}

